/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Searchproducts1Inputs */

const he_common_searchproducts1 = /** @type {(inputs: Common_Searchproducts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיפוש מוצרים...`)
};

const en_common_searchproducts1 = /** @type {(inputs: Common_Searchproducts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search products...`)
};

/**
* | output |
* | --- |
* | "Search products..." |
*
* @param {Common_Searchproducts1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_searchproducts1 = /** @type {((inputs?: Common_Searchproducts1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Searchproducts1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_searchproducts1(inputs)
	return en_common_searchproducts1(inputs)
});
export { common_searchproducts1 as "common_searchProducts" }